import { is } from '../is';

/**
 * Generate a list of assets from the schema. Removes duplicates and "rebalance" URLs to consume from different shards.
 * @param schema
 * @return {schema}
 */
export function generateAssetsList(schema) {
  const uniqueList = new Set(schema.assets);

  iterateAssetConsumers(schema, (url) => {
    uniqueList.add(url);
    return url;
  });

  const urlMap = new Map();
  [...uniqueList].forEach((url, index) => {
    const shardIndex = (index % 9) + 1;
    urlMap.set(url, url.replace(/\/\/s\d\.vcdn/, `//s${shardIndex}.vcdn`));
  });

  schema.assets = [...urlMap.values()];

  iterateAssetConsumers(schema, (url) => urlMap.get(url) || url);

  return schema;
}

function iterateAssetConsumers(schema, cb) {
  for (const widgetId in schema.widgets) {
    const widget = schema.widgets[widgetId];

    if (widget.type === 'image') {
      widget.url = cb(widget.url);
    }

    if (is.widget.slider(widget) && widget.thumbImageUrl) {
      widget.thumbImageUrl = cb(widget.thumbImageUrl);
    }
  }

  for (const bgId in schema.backgrounds) {
    const bg = schema.backgrounds[bgId];

    if (bg?.type === 'image') {
      bg.data = cb(bg.data);
    }
  }
}
